export default __webpack_public_path__ + "static/media/yourpayment.f84dbc6c.png";